import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Card, CardContent, Chip } from '@mui/material';

import { mapSubscriptionDurationToMonth } from 'src/utils/format-user-subscription-details';

import { PlanTileInputs } from './types';

export const PlanTile = ({ currencyCode, tier, onClick }: PlanTileInputs) => {
  const unit = tier.duration_months === 1 ? 'month' : `months`;
  return (
    <Card sx={{ width: '298px', height: '234px', borderRadius: '8px' }}>
      <Chip
        label={`Save ${tier.savings_value}%`}
        data-testid="discount-chip"
        sx={{
          backgroundColor: '#E21B70',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#E21B70'
          },
          visibility: tier.savings_value ? 'hidden' : 'visible',
          marginTop: '20px',
          borderRadius: '0 8px 8px 0px'
        }}
      />

      <CardContent>
        <Typography type="title-sm" color="neutral-primary">
          {mapSubscriptionDurationToMonth(tier.duration_months)}
        </Typography>
        <br />
        <Typography
          type="title-xl"
          color="tag-deal-background"
          style={{ display: 'inline' }}
        >
          {currencyCode} {tier.monthly_price}
        </Typography>
        <Typography
          type="label-md"
          color="tag-deal-background"
          style={{ display: 'inline' }}
        >
          / person / month
        </Typography>
        <Typography type="label-md" color="neutral-secondary">
          {currencyCode} {tier.billed_price} every {tier.duration_months} {unit}
        </Typography>
      </CardContent>
      <Button
        variant="primary"
        layout="full-width-primary"
        size="small"
        onClick={onClick}
        marginLeft="md"
        marginRight="md"
      >
        Subscribe
      </Button>
    </Card>
  );
};
